import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b7363ff")

_pushScopeId("data-v-4b7363ff")
const _hoisted_1 = { class: "tooltip" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "button" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["tooltip-wrap", { 'opened-popup': _ctx.openedPopup || _ctx.justClosedPopup }],
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMouseOver = true)),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.text), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "button", {}, undefined, true)
    ])
  ], 34))
})